import i18next from 'i18next';

const BYTES_PER_UNIT = 1024;

// Ordered smallest first; the index into this list doubles as the power of 1024 applied.
const UNITS = ['byte', 'kilobyte', 'megabyte', 'gigabyte'] as const;

/** Renders a file size the way a file manager does: "820 bytes", "1.4 kB", "9.7 MB". */
export default function formatByteSize(byteSize: number) {
  const isMeasurable = Number.isFinite(byteSize) && byteSize >= 0;
  const safeByteSize = isMeasurable ? byteSize : 0;

  let unitIndex = 0;
  let amount = safeByteSize;

  while (amount >= BYTES_PER_UNIT && unitIndex < UNITS.length - 1) {
    amount /= BYTES_PER_UNIT;
    unitIndex += 1;
  }

  return new Intl.NumberFormat(i18next.language, {
    // Whole bytes read oddly with a decimal place; every larger unit needs one.
    maximumFractionDigits: unitIndex === 0 ? 0 : 1,
    style: 'unit',
    unit: UNITS[unitIndex],
    unitDisplay: 'short',
  }).format(amount);
}
